var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("gg-select", {
        attrs: {
          dense: "",
          outlined: "",
          label: "Currently Managing:",
          items: _vm.subAccountsList,
          "item-value": "id",
          "hide-details": ""
        },
        on: {
          change: _vm.switchSubAccount
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                _vm._v(
                  " " + _vm._s(item.user) + " - " + _vm._s(item.domain) + " "
                )
              ]
            }
          },
          {
            key: "item",
            fn: function fn(_ref2) {
              var item = _ref2.item
              return [
                _vm._v(
                  " " + _vm._s(item.user) + " - " + _vm._s(item.domain) + " "
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.selectedAccount,
          callback: function callback($$v) {
            _vm.selectedAccount = $$v
          },
          expression: "selectedAccount"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }